import { flatten } from '80.quickConnect.Core/helpers';
import { FieldDesc } from '90.quickConnect.Models/models';

export const mapGroupIsVisibleItems = (fields: FieldDesc[]): FieldDesc[] => {
  const filterByFullPathId = new Set<string>();

  fields.forEach((field: FieldDesc) => {
    const { isVisible, items, visible } = field;

    if (items.length === 0 || (isVisible && visible !== false)) return;

    flatten(items, (i: FieldDesc) => i.items).forEach((f: FieldDesc) => filterByFullPathId.add(f.fullPathId));
  });

  return fields.filter((f: FieldDesc): boolean => !filterByFullPathId.has(f.fullPathId));
};
